<template>
  <div>
    <LoginHead />
    <p class="m-5 text-center">
      新しいバージョンがリリースされています
      <br />
      アプリをアップデートしてください
    </p>

    <p v-if="!isAndroid" class="pb-3 text-center">
      <a :href="externalLink.appStore">
        <img src="@/assets/svg/appStore/AppStoreBadge.svg" alt="" width="145" />
      </a>
    </p>
    <p v-if="!isIos" class="pb-3 text-center">
      <a :href="externalLink.googlePlay">
        <img
          src="@/assets/img/googlePlay/GooglePlayBadge.png"
          alt=""
          height="80"
        />
      </a>
    </p>
    <BlockBack />
  </div>
</template>

<script lang="ts">
import LoginHead from "@/components/molecules/other/LoginHead.vue";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { Component, Vue } from "vue-facing-decorator";
import { deviceModule } from "@/store/device";
import { authStore } from "@/store/auth";

@Component({
  components: {
    LoginHead,
    BlockBack
  }
})
export default class RequireUpdate extends Vue {
  get externalLink() {
    return {
      appStore: authStore.getPlatformStoreUrl("iOS"),
      googlePlay: authStore.getPlatformStoreUrl("Android")
    };
  }
  get isIos() {
    return deviceModule.isIos;
  }

  get isAndroid() {
    return deviceModule.isAndroid;
  }
}
</script>
